import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import './i18n';
import App from './App';
import AnalyticsProvider from './analytics/AnalyticsProvider';

// React 17 uses the legacy renderer; keep this until the app upgrades React.
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <AnalyticsProvider>
    <App />
  </AnalyticsProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
